function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import $ from 'jquery';
import Backbone from '@polleverywhere/backbone';
import DialogTpl from './templates/dialog.hamlc';
import BEM from '../../lib/mixins/_bem';
import { extend } from 'underscore';
var ESCAPE_KEY = 27;
/**
 * The modal dialog component is used to provide an explanation and confirmation
 * for more complex or destructive actions. For example, if a user wants to
 * delete a group of polls, we use a modal dialog to explain everything that we'll be deleting
 * and as an opportunity to confirm the action.
 *
 * @example <caption>Alert</caption>
 *   PollEv.Component.Modal.alert "Thank <strong>you</strong> for signing up!"
 *     allowHtml: true
 *
 * @example <caption>Confirm</caption>
 *   PollEv.Component.Modal.confirm "Are you sure you want to delete these items?
 *     simpleTitle: "Delete Items"
 *   .then (val) ->
 *     console.log "DELETING THEM ALL"
 *
 * @example <caption>Prompt</caption>
 *   PollEv.Component.Modal.prompt "What would you like for lunch?", "Banana"
 *     .then (val) ->
 *       console.log "Okay, sure, here's a #{val}"
 *     .fail ->
 *       console.error "Why nothing?"
 *
 * @example <caption>Complex dialog</caption>
 *   dialog = new Modal.Dialog
 *     content: "All your polls were lost, sorry :("
 *
 *   dialog.once "click:primary", ->
 *     # TODO Handle click of OK button
 *   dialog.once "close", ->
 *     # TODO Handle click of close button
 *     dialog.remove()
 *
 *   dialog.open()
 */

var Dialog = /*#__PURE__*/function (_Backbone$View) {
  _inheritsLoose(Dialog, _Backbone$View);

  function Dialog() {
    return _Backbone$View.apply(this, arguments) || this;
  }

  var _proto = Dialog.prototype;
  /**
   * Construct dialog object
   * render() is automatically called on initialize, there is no need to call render() or to insert the $el anywhere.
   *
   * @param {Object} options merged into default options
   * @param {String} options.size x-small, small, medium, or large
   * @param {Boolean} options.preventScrollingOffscreen (Default: false) Set in
   *   order to prevent modal body content from running off the screen.
   * @param {String} options.content (Default: "") The main content to display.
   *
   * @param {Object} options.header
   * @param {Boolean} options.header.show (Default: false) Whether or not to show the header
   * @param {Boolean} options.header.title (Default: "") Title shown on the modal header
   * @param {Boolean} options.header.transparentBackground (Default: false) Whether the header background color is set to transparent.
   *
   * @param {Boolean} options.footer
   * @param {Boolean} options.footer.show Whether or not to show the footer
   *
   * @param {Object} options.actions
   * @param {String|Boolean} options.actions.primary (Default: "OK") The text to show on the primary button. Will hide the button if falsey
   * @param {String|Boolean} options.actions.secondary (Default: false) The text to show on the secondary button. Will hide the button if falsey
   * @param {String|Boolean} options.actions.cancel (Default: false) The text to show on the cancel button. Will hide the button if falsey
   *
   * @param {Object} options.ignoreCloseOn
   * @param {Boolean} options.ignoreCloseOn.backdrop (Default: false) Pass true to prevent hiding the modal if the backdrop is clicked
   * @param {Boolean} options.ignoreCloseOn.escape (Default: false) Pass true to prevent hiding the modal if escape is pressed
   *
   * @emits {open} Modal starts to open
   * @emits {open:complete} Modal is fully open
   * @emits {close} Modal starts to close
   * @emits {close:complete} Modal is fully closed
   * @emits {click:primary} Primary (OK) button is clicked
   * @emits {click:secondary} Secondary button is clicked
   * @emits {click:cancel} Cancel button is clicked
   * @emits {click:backdrop} Backdrop outside the modal is clicked
   * @emits {click:escape} Escape keystroke is pressed
   */

  _proto.initialize = function initialize(options) {
    this.boundKeyAction = this._keyAction.bind(this);

    _Backbone$View.prototype.initialize.apply(this, arguments);

    extend(this, BEM(this)); // Underscore only does a shallow extension, we need it to be deep

    this.options = $.extend(true, {}, this.defaults, options);
    this.isOpen = false; // Backwards compatible for those that may still be using a boolean

    if (this.options.actions.cancel === true) {
      this.options.actions.cancel = 'Cancel';
    }

    this.render();

    if (this.options.content) {
      this.setContent(this.options.content);
    }
  }
  /**
   * TODO: Fix this function to update all options as if a new modal dialog
   * was constructed with the different option values. Right now, it only
   * updates footer content and a portion of options passed in.
   *
   * Allows reconfiguring of initial options
   * @param {Object} options See default options
   */
  ;

  _proto.reconfigure = function reconfigure(options) {
    this.options = $.extend(true, this.options, options);

    this._setState();

    return this;
  }
  /**
   * Generate view DOM elements
   * @return {View} this view
   */
  ;

  _proto.render = function render() {
    _Backbone$View.prototype.render.apply(this, arguments);

    this.$el.html(DialogTpl());

    this._setState();

    this.$el.appendTo(document.body);
    return this;
  } // Remove from the DOM
  ;

  _proto.remove = function remove() {
    var superRemove = _Backbone$View.prototype.remove;

    var doRemove = function () {
      this._clearContent();

      superRemove.call(this);
    }.bind(this);

    if (this.isOpen) {
      this.once('close:complete', doRemove);
      this.close();
    } else {
      doRemove();
    }
  }
  /**
   * Sets the modal body content
   *
   * @param {Object} content Can be a string, $ element or Backbone View
   */
  ;

  _proto.setContent = function setContent(content) {
    var body = this.$('.modal-dialog--body');

    this._clearContent();

    if (typeof content === 'string') {
      body.html(content);
    } else if (content instanceof $) {
      body.append(content);
    } else if (content instanceof Backbone.View) {
      this.subView = content.render();
      body.append(this.subView.$el);
    }

    return this;
  } // Open the dialog
  ;

  _proto.open = function open() {
    var _this = this;

    if (!this.isOpen) {
      $(document).on("keydown." + this.cid, this.boundKeyAction);
      $(document.body).toggleClass('s-open-modal', true);
      this.isOpen = true;
      this.$el.fadeIn().promise().then(function () {
        if (_this.isOpen) {
          return _this.trigger('open:complete');
        }
      });
      this.trigger('open');
    }

    return this;
  } // Close the dialog
  ;

  _proto.close = function close() {
    var _this2 = this;

    if (this.isOpen) {
      $(document).off("." + this.cid);
      $(document.body).toggleClass('s-open-modal', false);
      this.isOpen = false;
      this.$el.fadeOut().promise().then(function () {
        if (!_this2.isOpen) {
          return _this2.trigger('close:complete');
        }
      });
      this.trigger('close');
    }

    return this;
  } // @private
  ;

  _proto._clearContent = function _clearContent() {
    if (this.subView != null) {
      this.subView.remove();
    }

    this.$('.modal-dialog--body').empty();
  } // @private
  ;

  _proto._setState = function _setState() {
    var _this3 = this;

    this.$el.removeClass('s-x-small s-small s-medium s-large');
    this.$el.toggleClass("s-" + this.options.size, true); // Need the explicit true check since $ will just toggle classes on and
    // off if passed undefined

    this.$el.toggleClass('s-no-scroll-offscreen', this.options.preventScrollingOffscreen === true);
    this.$('.modal-dialog--header').toggleClass('hidden', !(this.options.header.show || this.options.header.title));
    this.$('.modal-dialog--footer').toggleClass('hidden', !this.options.footer.show);

    if (this.options.footer.show) {
      ['primary', 'secondary', 'cancel'].forEach(function (cta) {
        var el = _this3.$(".modal-dialog--" + cta);

        el.toggleClass('hidden', !_this3.options.actions[cta]);

        if (_this3.options.actions[cta]) {
          el.text(_this3.options.actions[cta]);
        }
      });
    }

    if (this.options.header.title) {
      this.$('.modal-dialog--title').toggleClass('hidden', false).text(this.options.header.title);
    } else {
      this.$('.modal-dialog--title').toggleClass('hidden', true);
    }

    this.$_toggleModifier(this.$el, 'modal-dialog--header', 'transparent-background', this.options.header.transparentBackground);
  } // @private
  ;

  _proto._clickPrimary = function _clickPrimary() {
    this.trigger('click:primary');
  } // @private
  ;

  _proto._clickSecondary = function _clickSecondary() {
    this.trigger('click:secondary');
  } // @private
  ;

  _proto._clickCancel = function _clickCancel() {
    this.trigger('click:cancel');
    this.close();
  } // @private
  ;

  _proto._clickClose = function _clickClose() {
    this.trigger('click:close');
    this.close();
  } // @private
  ;

  _proto._clickBackdrop = function _clickBackdrop() {
    this.trigger('click:backdrop');

    if (!this.options.ignoreCloseOn.backdrop) {
      this.close();
    }
  } // @private
  ;

  _proto._keyAction = function _keyAction(e) {
    if (e.which === ESCAPE_KEY) {
      this.trigger('click:escape');

      if (!this.options.ignoreCloseOn.escape) {
        this.close();
      }
    }
  };

  _createClass(Dialog, [{
    key: "className",
    get: function get() {
      return 'modal-dialog';
    }
  }, {
    key: "elementTpl",
    get: function get() {
      return DialogTpl;
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        size: 'medium',
        content: '',
        header: {
          show: false,
          title: '',
          transparentBackground: false
        },
        footer: {
          show: true
        },
        actions: {
          primary: 'OK',
          secondary: false,
          cancel: false
        },
        ignoreCloseOn: {
          backdrop: false,
          escape: false
        }
      };
    }
  }, {
    key: "events",
    get: function get() {
      return {
        'click .modal-dialog--primary': '_clickPrimary',
        'click .modal-dialog--secondary': '_clickSecondary',
        'click .modal-dialog--cancel': '_clickCancel',
        'click .modal-dialog--close': '_clickClose',
        'click .modal-dialog--backdrop': '_clickBackdrop'
      };
    }
  }]);

  return Dialog;
}(Backbone.View);

export { Dialog as default };
;